export default "__VITE_ASSET__CWYvAReh__"